import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import InputFile from '../../components/inputFile';
import Input from "../../components/Input";
import { getOrDeleteRequest, postOrPutRequest, validateData } from "../../utils/utils";
import FormError from "../../components/FormError";
import SelectMultiple from "../../components/SelectMultiple";

const InfoOrg2 = ({ data }) => {
    const [formulario, setFormulario] = useState({
        business_sectors: data.business_sectors || '',
        trade_name: data.trade_name || '',
        document_type: data.document_type || 'nit',
        nit: data.nit || '',
        dui: data.dui || '',
        other_document: data.other_document || '',
        name_other_document: data.name_other_document || '',
        phone: data.phone || '',
    });

    const [businessSectors, setBusinessSectors] = useState([]);
    const [alert, setAlert] = useState([{
        inputName: "",
        status: false,
        message: "",
    }]);
    const [loading, setLoading] = useState(false);
    const [fileName, setFileName] = useState("");

    const handleChange = (e) => {
        let newForm = { ...formulario };
        newForm[e.target.name] = e.target.value;
        
        sessionStorage.setItem('infoOrg', JSON.stringify(newForm));
        setFormulario(newForm);
    };

    const handleDocumentTypeChange = (value) => {
        const newForm = { 
            ...formulario, 
            document_type: value,
            // Limpiar otros campos de documento al cambiar tipo
            nit: value === 'nit' ? formulario.nit : '',
            dui: value === 'dui' ? formulario.dui : '',
            other_document: value === 'other' ? formulario.other_document : '',
            name_other_document: value === 'other' ? formulario.name_other_document : ''
        };
        
        sessionStorage.setItem('infoOrg', JSON.stringify(newForm));
        setFormulario(newForm);
    };

    const getBusinessSectors = async () => {
        setLoading(true);
        let response = await getOrDeleteRequest(
            `business_sectors/filter`,
            'GET',
            null,
            false
        );

        if (response.type === 'success') {
            setBusinessSectors(response.data);
        }
        setLoading(false);
    };

    const validateDataForm = (e) => {
        e.preventDefault();

        let inputs = Object.entries(formulario)
            .filter(([key]) => {
                // Solo validar los campos de documento que correspondan al tipo seleccionado
                if (key === 'nit') return formulario.document_type === 'nit';
                if (key === 'dui') return formulario.document_type === 'dui';
                if (key === 'other_document' || key === 'name_other_document') 
                    return formulario.document_type === 'other';
                return true;
            })
            .map(([name, value]) => ({ name, value }));

        const datosValidados = validateData(inputs);
        setAlert(datosValidados);

        if (datosValidados.every(input => !input.status)) {
            // Continuar con el envío de datos si no hay errores
            // console.log("Datos válidos, proceder con envío");
        }
    };

    const allFunctions = async () => {
        await getBusinessSectors();

        if (sessionStorage.getItem('infoOrg')) {
            const sessionData = JSON.parse(sessionStorage.getItem('infoOrg'));
            setFormulario(prev => ({
                ...prev,
                ...sessionData,
                // Mantener los valores por defecto si no existen en sessionStorage
                business_sectors: sessionData.business_sectors || prev.business_sectors,
                trade_name: sessionData.trade_name || prev.trade_name
            }));
        }
    };

    useEffect(() => {
        allFunctions();
    }, []);

    return (
        <form onSubmit={validateDataForm}>
            {/* Sector Comercial */}
            <div className="mb-4">
                <SelectMultiple
                    name="business_sectors"
                    label="Sector comercial"
                    loading={loading}
                    array={businessSectors}
                    isMulti={false}
                    required={true}
                    alert={alert}
                    value={formulario.business_sectors}
                    placeholder="Seleccione sector comercial"
                    onChange={(e) => handleChange({ target: { name: 'business_sectors', value: [e] } })}
                />
                <FormError errors={alert} name="business_sectors" />
            </div>

            {/* Razón Social */}
            <div className="mb-4">
                <Input
                    type="text"
                    name="trade_name"
                    label="Razón social"
                    required={true}
                    alert={alert}
                    value={formulario.trade_name}
                    onChange={handleChange}
                />
                <FormError errors={alert} name="trade_name" />
            </div>

            {/* Tipo de Documento */}
            <div className="mb-4">
                <SelectMultiple
                    name="document_type"
                    label="Tipo de documento"
                    array={[
                        { id: 'nit', name: 'NIT' },
                        { id: 'dui', name: 'DUI' },
                        { id: 'other', name: 'Otro documento' }
                    ]}
                    isMulti={false}
                    required={true}
                    alert={alert}
                    value={formulario.document_type}
                    onChange={handleDocumentTypeChange}
                />
                <FormError errors={alert} name="document_type" />
            </div>

            {/* Campos de documento condicionales */}
            {formulario.document_type === 'nit' && (
                <div className="mb-4">
                    <Input
                        type="text"
                        name="nit"
                        label="NIT"
                        required={true}
                        alert={alert}
                        mask="9999-999999-999-9"
                        value={formulario.nit}
                        onChange={handleChange}
                        placeholder="0000-000000-000-0"
                    />
                    <FormError errors={alert} name="nit" />
                </div>
            )}

            {formulario.document_type === 'dui' && (
                <div className="mb-4">
                    <Input
                        type="text"
                        name="dui"
                        label="DUI"
                        required={true}
                        alert={alert}
                        mask="99999999-9"
                        value={formulario.dui}
                        onChange={handleChange}
                        placeholder="00000000-0"
                    />
                    <FormError errors={alert} name="dui" />
                </div>
            )}

            {formulario.document_type === 'other' && (
                <>
                    <div className="mb-4">
                        <Input
                            type="text"
                            name="name_other_document"
                            label="Tipo de documento"
                            required={true}
                            alert={alert}
                            value={formulario.name_other_document}
                            onChange={handleChange}
                            placeholder="Ej: Pasaporte, Carnet de Residencia"
                        />
                        <FormError errors={alert} name="name_other_document" />
                    </div>
                    <div className="mb-4">
                        <Input
                            type="text"
                            name="other_document"
                            label="Número de documento"
                            required={true}
                            alert={alert}
                            value={formulario.other_document}
                            onChange={handleChange}
                            placeholder="Número completo"
                        />
                        <FormError errors={alert} name="other_document" />
                    </div>
                </>
            )}

            {/* Teléfono */}
            <div className="mb-4">
                <Input
                    type="text"
                    name="phone"
                    label="Teléfono"
                    required={true}
                    alert={alert}
                    mask="9999-9999"
                    prefix="+503 "
                    value={formulario.phone}
                    onChange={handleChange}
                    placeholder="0000-0000"
                />
                <FormError errors={alert} name="phone" />
            </div>
        </form>
    );
};

export default InfoOrg2;